export default __webpack_public_path__ + "static/media/infernoofamher.9d34782c.png";